module.exports = __webpack_public_path__ + "img/382.0e34942a.jpg";